<template>
  <div class="middle-bottom">
    <div class="mhead">
      <div class="item state-0">空闲</div>
      <div class="item state-1">使用中</div>
      <div class="item state-3">维护中</div>
    </div>
    <div class="table">
      <div class="thead">
        <div class="i-item name">设备类型</div>
        <div class="i-item percent">使用频次</div>
        <!-- <div class="i-item kcal">设备数量</div> -->
      </div>
      <div class="tbody high">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="item.name">
            <div class="i-item name">
              <div class="left">
                <div class="avatar">
                  <img :src="item.big_icon" />
                </div>
                {{ item.name }}
              </div>
              <div class="right">
                <div class="n-item" :class="`state-${row.runstate}`" v-for="(row, index) in item.list" :key="index">{{ row.label }}</div>
              </div>
            </div>
            <div class="i-item percent">{{ item.num }}</div>
            <!-- <div class="i-item kcal">{{ item.count }}</div> -->
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
let mtimer = null
let ltimer = null

export default {
  filters: {
    num(val) {
      if (val < 10) {
        val = 'No.00' + val
      } else if (val < 100) {
        val = 'No.0' + val
      } else {
        val = 'No.' + val
      }
      return val
    },
  },
  props: {
    count: {
      default: 10,
    },
    list: {
      default() {
        return []
      },
    },
  },
  watch: {
    list: {
      deep: true,
      handler() {
        clearInterval(ltimer)
        this.init()
      },
    },
  },
  data() {
    return {
      page_size: 5,

      active: 1,

      p_step: 0,
      c_step: 0,

      p_list: [],
      pList: [],
      c_list: [],
      cList: [],
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearInterval(ltimer)
  },
  methods: {
    init() {
      this.page_size = 4

      this.p_step = 0
      this.pList = this.list

      this.$set(this, 'p_list', this.list.slice(0, this.page_size))
      ltimer = setInterval(() => {
        this.p_list = []

        setTimeout(() => {
          let p_step = this.p_step + 1

          // console.log(p_step, Math.floor(this.pList.length / this.page_size))

          if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
            p_step = 0
          }

          this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

          this.p_step = p_step
        }, 600)
      }, 20000)
    },
    on_change(i) {
      this.active = i
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.middle-bottom {
  .mhead {
    margin-top: -60px;
    padding: 13px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      font-size: 12px;
      color: #fff;
      display: flex;
      align-items: center;
      & + .item {
        margin-left: 12px;
      }
      &::before {
        content: ' ';
        display: block;
        width: 18px;
        height: 18px;
        margin-right: 8px;
        border-radius: 2px;
        background: #75bb43;
      }
      &.state-0 {
        &::before {
          background: #75bb43;
        }
      }
      &.state-1 {
        &::before {
          background: #f7b500;
        }
      }
      &.state-3 {
        &::before {
          background: #ff6c40;
        }
      }
    }
  }
  .table {
    margin: 20px 0px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 200px;
      overflow: auto;
      &.high {
        height: 452px;
      }
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        &:nth-of-type(even) {
          background: #002972;
        }
        .i-item {
          font-size: 16px;
          font-weight: normal;
          padding: 6px 0;
          color: #82a9ef;
          &.name {
            font-size: 12px;
          }
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 6px 0;
      &.name {
        width: 70%;
        padding-left: 12px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .left {
          width: 200px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          flex-direction: column;
          overflow: hidden; /* 超出部分隐藏 */
          white-space: nowrap; /* 文本不换行 */
          text-overflow: ellipsis; /* 省略的文本用省略号表示 */
          .avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 4px;
            background: #005ed2;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 18px;
              height: 18px;
            }
          }
        }
        .right {
          display: flex;
          flex-wrap: wrap;
          .n-item {
            font-size: 12px;
            color: #ffffff;
            background: #204faa;
            border-radius: 4px;
            padding: 4px 4px 4px 8px;
            margin-right: 4px;
            margin-top: 4px;
            position: relative;
            &::before {
              content: ' ';
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              width: 6px;
              height: 100%;
              background: #75bb43;
              border-radius: 4px;
            }
            &.state-0 {
              &::before {
                background: #75bb43;
              }
            }
            &.state-1 {
              &::before {
                background: #f7b500;
              }
            }
            &.state-3 {
              &::before {
                background: #ff6c40;
              }
            }
          }
        }
      }
      &.percent {
        text-align: center;
        width: 30%;
      }
      &.kcal {
        text-align: center;
        width: 20%;
      }
    }
  }
}
</style>
